export const getURL = (): string => {
  return 'https://api-dev-cofco.agrodata.agr.br/';
  return process.env.REACT_APP_API_BASE_URL as string;
};
